export default "__VITE_ASSET__DZ9_lzy9__"